import { cn } from "@/lib/utils";

type SkodaLogoPropsT = {
  className?: string;
  fill?: string;
  width?: number | string;
  height?: number | string;
};

export default function SkodaLogo({
  className,
  fill = "currentColor",
  width = 73,
  height = 11,
}: SkodaLogoPropsT) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 73 11"
      className={cn(className)}
    >
      <path
        d="M14.8515 10.1159V0.000996346H17.2607V3.93955H20.455L24.6048 0.000996346H27.7981L22.5204 5.02956L27.8937 10.1159H24.5091L20.3593 6.11956H17.2617V10.1159H14.8525H14.8515ZM5.02956 2.10428L3.65261 0.000996346H11.9711L10.632 2.10428H5.02956ZM62.445 6.19628H67.3022L64.8731 1.89405L62.444 6.19628H62.445ZM57.55 10.1159L63.2291 0.000996346H66.5759L72.2551 10.1159H69.5011L68.5257 8.37628H63.6875L62.3872 6.31086L60.2461 10.1159H57.55ZM37.5623 10.1159H32.3803C29.9322 10.1159 28.5174 8.70109 28.5174 6.34872V3.76719C28.5174 1.41481 29.9332 0 32.3803 0H37.5623C40.0103 0 41.4251 1.41481 41.4251 3.76719V6.34872C41.4251 8.70109 40.0103 10.1159 37.5623 10.1159ZM32.4381 7.9359H37.5055C38.4231 7.9359 39.0159 7.362 39.0159 6.4633V3.65261C39.0159 2.7539 38.4231 2.18001 37.5055 2.18001H32.4381C31.5204 2.18001 30.9276 2.7539 30.9276 3.65261V6.4633C30.9276 7.362 31.5204 7.9359 32.4381 7.9359ZM44.1142 10.1159V0.000996346H52.5852C55.1089 0.000996346 56.5626 1.45367 56.5626 3.86383V6.25407C56.5626 8.66323 55.1089 10.1169 52.5852 10.1169H44.1142V10.1159ZM46.5234 7.9359H52.5274C53.5217 7.9359 54.1524 7.32414 54.1524 6.36765V3.74826C54.1524 2.79276 53.5217 2.18001 52.5274 2.18001H46.5234V7.9359ZM0 10.1159L1.33909 7.97376H9.10262C9.54301 7.97376 9.82896 7.68681 9.82896 7.24742V6.00398H3.15543C1.16672 6.00398 0.286948 5.12421 0.286948 3.17436V2.33344C0.286948 0.879774 1.14779 0.000996346 2.50482 0.000996346H2.65825V3.1365C2.65825 3.57688 2.9452 3.86284 3.38459 3.86284H9.84789C11.3205 3.86284 12.2003 4.74261 12.2003 6.17635V7.28529C12.2003 9.17834 11.2637 10.1149 9.33178 10.1149H0V10.1159Z"
        fill={fill}
      />
    </svg>
  );
}
